import React, { useEffect, useState } from 'react'
import * as Styles from './MoreChannel.style'
import WKInfiniteScroll from '@/components/WKInfiniteScroll/WKInfiniteScroll'
import { ILiveRoomItem, SEARCH_TYPE } from '../../../services/Modules/searchServer'
import HttpServer from '../../../services/server'
import { RouteProps } from 'react-router'
import Channeltem from '../components/Channeltem/Channeltem'
import Loading from '@/components/Loading/Loading'
import { getLocationParamValue } from '../../../utils/tools'

export default function MoreChannel(props: RouteProps) {
  const keyword = decodeURIComponent(getLocationParamValue('keyword') || '')
  if (!keyword) {
    return null
  }
  const [isLoading, setIsloading] = useState(false)
  const [hasMore, setHasMore] = useState(false)
  const [isInited, setIsInited] = useState(false)
  const [list, setList] = useState<ILiveRoomItem[]>([])
  const [page, setPage] = useState(1)
  const size = 10

  useEffect(() => {
    getList().then(() => {
      setIsInited(true)
    })
  }, [])

  async function getList() {
    try {
      setIsloading(true)
      const data = await HttpServer.getSearch<ILiveRoomItem>({ keyword, type: SEARCH_TYPE.CHANNEL, offset: (page - 1) * size })
      setList([...list, ...data.data.data.records])
      setHasMore(data.data.data.has_more)
      setPage(page + 1)
      setIsloading(false)
    } catch (error) {
      console.log(error.message)
    }
  }

  return (
    <div className={Styles.container}>
      {isInited ? (
        <div className={Styles.list}>
          {list.map(item => {
            // todo: 特例，卢文建的课程不可搜索
            if (item.id === 320857) { return <></> }
            return <Channeltem key={item.id} content={item} />
          })}
          <WKInfiniteScroll
            onTouchBottom={getList} // 到达底部执行的方法
            isStop={isLoading} // 暂停执行onTouchBottom，一般是正在请求接口时触发
            distance={200} // 距离底部多少px触发
            isKill={!hasMore} // 不再监听滚动，一般是传!has_more
            isShowLoading={true} // 请求数据的时候（isStop）是否显示菊花
          />
        </div>
      ) : (
        <Loading />
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/SearchResult/MoreChannel/MoreChannel.tsx